import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { useProjectStore } from '../../store/projectStore';

const LOG_URL = '/UPDATE_LOG.txt';

const WhatsNewView: React.FC = () => {
  const { appTheme } = useProjectStore();
  const isDark = appTheme === 'dark';
  const [text, setText] = useState('');
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    setStatus('loading');
    fetch(LOG_URL, { cache: 'no-store' })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.text();
      })
      .then((body) => {
        if (cancelled) return;
        setText(body.trim());
        setStatus('ready');
      })
      .catch(() => {
        if (cancelled) return;
        setStatus('error');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const muted = isDark ? '#9ca3af' : '#6b7280';
  const body = isDark ? '#d1d5db' : '#1f2937';

  return (
    <div
      className="flex-1 flex flex-col overflow-hidden"
      style={{ backgroundColor: isDark ? '#171a1f' : '#e8eaed' }}
    >
      <div
        className="flex-shrink-0 flex items-center gap-2 px-6 py-3 border-b"
        style={{
          backgroundColor: isDark ? '#1e2330' : '#ffffff',
          borderColor: isDark ? '#343a43' : '#e5e7eb',
        }}
      >
        <Sparkles size={18} className="text-blue-500" />
        <h1
          className="text-lg font-semibold"
          style={{ color: isDark ? '#f3f4f6' : '#111827' }}
        >
          What’s New
        </h1>
      </div>
      <div className="flex-1 overflow-y-auto custom-scrollbar">
        <div
          className="max-w-2xl mx-auto my-6 px-5 py-6 rounded-lg shadow-sm"
          style={{
            backgroundColor: isDark ? '#1e2330' : '#ffffff',
            border: isDark ? '1px solid #343a43' : '1px solid #e5e7eb',
          }}
        >
          {status === 'loading' && (
            <p className="text-sm m-0" style={{ color: muted }}>Loading…</p>
          )}
          {status === 'error' && (
            <p className="text-sm m-0" style={{ color: muted }}>
              Couldn’t load the update log. Try refreshing the page.
            </p>
          )}
          {status === 'ready' && (
            <pre
              className="whitespace-pre-wrap font-sans text-sm leading-relaxed m-0"
              style={{ color: body }}
            >
              {text}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhatsNewView;
